import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overview-container tw-flex tw-gap-[20px] tw-flex-wrap" }
const _hoisted_2 = { class: "tw-flex-1 tw-h-[113px]" }
const _hoisted_3 = { class: "tw-flex-1 tw-rounded-md tw-border-solid tw-border tw-border-[#EFF0F1]" }
const _hoisted_4 = { class: "tw-flex-1 tw-h-[113px] tw-bg-[#FFF] tw-rounded-md tw-border-solid tw-border tw-border-[#EFF0F1] tw-py-[20px] tw-pl-[20px]" }

import IssueNumberBlocks from "./IssueNumberBlocks.vue";
import NextScanMiniDash from "./nextScanMiniDash.vue";
import ScanNavigationSpinner from "./scanNavigationSpinner.vue";
import ScanStatusMiniDash from "./scanStatusMiniDash.vue";
import { type ScansHistoryWebServicesType } from "@/store/scanning";
import { computed, PropType, ref, watch } from "vue";
import { statusScanProgress, TYPE_SCHEDULE } from "@/utils/constants";
import ScanningTypes from "@/components/scanning/scanningTypes/index.vue";
import issuesOverTimeMiniGraph from "./issuesOverTimeMiniGraph.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'webServicesDetailTab',
  props: {
  data: {
    type: Object as PropType<
      ScansHistoryWebServicesType & { domainId: number }
    >,
    required: true,
  },
  scanTargetType: {
    type: String as PropType<keyof typeof TYPE_SCHEDULE>,
    required: false,
    default: TYPE_SCHEDULE.webservices,
  },
  statusProgress: {
    type: String,
    required: true,
  },
  isExpand: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["hoverIn", "hoverOut"],
  setup(__props) {

const props = __props;



const currentIndex = ref(props.data?.latestScanIndex);

watch(
  () => props.data.latestScanIndex,
  (value) => {
    currentIndex.value = value;
  },
  {
    immediate: true,
    deep: true,
  },
);

const currentScan = computed(
  () => props.data.scanReportRuns?.[currentIndex.value],
);
const totalScan = computed(() => props.data.scanReportRuns?.length || 0);

const switchScan = (mode: "next" | "prev" | "latest") => {
  if (mode === "latest") {
    currentIndex.value = props.data.latestScanIndex;
    return;
  }

  const total = props.data.scanReportRuns.length;
  let nextIndex = currentIndex.value + (mode === "next" ? 1 : -1);
  if (nextIndex === total) {
    nextIndex = 0;
  }
  if (nextIndex === -1) {
    nextIndex = total - 1;
  }
  currentIndex.value = nextIndex;
};

return (_ctx: any,_cache: any) => {
  return (currentScan.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tw-p-[25px] tw-flex tw-flex-col tw-gap-y-[25px] tw-bg-[#f2f8ff80] tw-border tw-border-b tw-border-t-[0px] tw-border-solid tw-border-[#EFF0F1]",
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hoverIn'))),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('hoverOut')))
      }, [
        _createVNode(ScanNavigationSpinner, {
          data: currentScan.value,
          "scan-report-runs": props.data.scanReportRuns,
          "web-services-id": __props.data.webserviceId || '',
          "domain-id": __props.data.domainId || '',
          "is-show-next": currentIndex.value < totalScan.value - 1,
          "is-show-prev": currentIndex.value > 0,
          "is-show-switch-scan": currentIndex.value !== __props.data.latestScanIndex,
          "scan-target-type": __props.scanTargetType,
          onSwitchScan: switchScan
        }, null, 8, ["data", "scan-report-runs", "web-services-id", "domain-id", "is-show-next", "is-show-prev", "is-show-switch-scan", "scan-target-type"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(ScanStatusMiniDash, {
              "web-services-id": __props.data.webserviceId || '',
              "domain-id": __props.data.domainId || '',
              data: currentScan.value,
              "percent-progress": 
            currentScan.value.runStatusId === _unref(statusScanProgress).SCAN_COMPLETE
              ? 100
              : 40
          
            }, null, 8, ["web-services-id", "domain-id", "data", "percent-progress"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(NextScanMiniDash, { data: __props.data }, null, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(issuesOverTimeMiniGraph, {
              id: __props.scanTargetType + '-' + __props.data.id,
              severity: __props.data.scanReportRuns
            }, null, 8, ["id", "severity"])
          ])
        ]),
        _createVNode(IssueNumberBlocks, {
          data: currentScan.value,
          "web-services-id": __props.data.webserviceId || '',
          "domain-id": __props.data.domainId || '',
          severity: {
        critical: currentScan.value.critical,
        high: currentScan.value.high,
        medium: currentScan.value.med,
        low: currentScan.value.low,
      }
        }, null, 8, ["data", "web-services-id", "domain-id", "severity"]),
        (__props.statusProgress === _unref(statusScanProgress).SCAN_COMPLETE)
          ? (_openBlock(), _createBlock(ScanningTypes, {
              key: 0,
              "is-expand": __props.isExpand,
              "run-id": currentScan.value.scanReportRunId,
              "scan-target-type": __props.scanTargetType,
              "root-id": 
        __props.scanTargetType === _unref(TYPE_SCHEDULE).webservices
          ? __props.data.webserviceId
          : __props.data.domainId
      ,
              "hover-bg-color": 'hover:tw-bg-[#F2F8FF]'
            }, null, 8, ["is-expand", "run-id", "scan-target-type", "root-id"]))
          : _createCommentVNode("", true)
      ], 32))
    : _createCommentVNode("", true)
}
}

})